import React, { useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import FreeGuide from "../components/FreeGuide";

/*
 //explanations:
 - This page reads the generated guide passed in via navigate(..., { state })
 - It renders the same FreeGuide card (keeps look) and a separate Premium box
   explaining what the full guide contains with a placeholder PDF link.
*/

export default function Preview() {
  const location = useLocation();
  const guide = location?.state?.guide || null;
  const formData = location?.state?.formData || null;

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'instant' });
    }, 50);
  }, []);

  return (
    <div className="min-h-screen bg-background flex flex-col items-center px-4 py-8">
      <header className="text-center mb-6">
        <img src="/logo.png" alt="RouteMuse Logo" className="w-48 mx-auto mb-2" />
        <h2 className="text-2xl font-bold text-primary">Free Guide Preview</h2>
      </header>

      {!guide && (
        <div className="w-full max-w-md bg-white p-6 rounded-2xl shadow-lg text-center text-gray-500 mb-6">
          No guide data found.{" "}
          <Link to="/" className="text-primary underline">Plan a trip</Link> to generate one.
        </div>
      )}

      {guide?.longDayWarning && (
        <div className="w-full max-w-md bg-amber-50 border border-amber-200 rounded-2xl p-4 mb-4 text-amber-800 text-sm">
          ⚠️ {guide.longDayWarning}
        </div>
      )}

      <div className="w-full max-w-md mb-6">
        <FreeGuide guide={guide} />
      </div>

      {/* Premium box explaining the paid full guide */}
      <div id="full-guide-info" className="w-full max-w-md bg-white p-6 rounded-2xl shadow-lg">
        <h3 className="text-xl font-bold mb-2">What the Premium Full Guide includes</h3>
        <ul className="list-disc pl-5 text-gray-700 space-y-2 mb-4">
          <li>Full day-by-day itinerary with time estimates</li>
          <li>Sightseeing details and POI descriptions</li>
          <li>Estimated fuel, tolls and travel time breakdown</li>
          <li>Turn-by-turn links and map markers</li>
          <li>Beautifully styled PDF delivered by email</li>
        </ul>

        <p className="text-sm text-gray-600 mb-4">
          Preview a sample full guide (PDF):
        </p>

        {/*explanations: placeholder link — replace with real hosted sample PDF or put example-full-guide.pdf in /public */}
        <a
          href="https://routemuse.me/wp-content/uploads/2026/04/Sample-guide.pdf"
          target="_blank"
          rel="noreferrer"
          className="inline-block mb-3 text-center px-6 py-3 rounded-xl shadow-md bg-accent text-white hover:bg-highlight transition"
        >
          View example PDF
        </a>

        <div className="mt-4 grid gap-2">
          <Link
            to="/upgrade"
            state={{ fromApp: true }}
            className="text-center px-4 py-2 rounded-lg border hover:bg-background"
          >
            Upgrade to Full Guide / Purchase
          </Link>
          <Link
            to="/"
            className="text-center px-4 py-2 rounded-lg border hover:bg-background"
          >
            Back to Planner
          </Link>
        </div>
      </div>
    </div>
  );
}